<template>
  <div>
    <b-container class="" id="">
      <select id="officeT" @change="goFunction($event.target.value)" style="z-index:1;">
        <option value="customerCare">APDCL Customer Care</option>
        <option value="kofficial">Key Officials(HQ) Contact</option>
        <option value="zone">Field Office:Zone</option>
        <option value="circle">Field Office:Circle</option>
        <option value="division">Field Office:Division</option>
        <option value="subdivision">Field Office:Sub-Division</option>
        <option value="irca">Field Office:IRCA</option>
        <option value="tc">Field Office:T&C Division</option>
        <option value="agm">District-Wise AGM(Project) Contact</option>
      </select>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'ContactMobileDropDown',
  methods: {
    goFunction(value) {
      // This value represents the section id like 'subdivision' or 'division'
      this.goto(value);
    },
    goto(id) {
      // FIXED: Safely broadcast tab changing event to the root tree listener
      this.$root.$emit('change-contact-tab', id);
      
      // Update the URL hash cleanly so users can reference deep links
      if (window.location.hash !== '#' + id) {
        window.location.hash = id;
      }
    }
  }
}
</script>

<style scoped="true">
/* Custom native select formatting constraints */
#officeT {
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background-color: #fff;
}

.custom-row {
  margin-right: 0;
  margin-left: 0;
  height:50px;
}

.btn-block{
  height:100%;
  width:100% !important;
  text-align: left;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.2px;
  border:none;
  border-bottom:1px solid;
}

.btn-color{
  color: #616161;
  background-color: #ffff;
  border-color: #e0e0e0;
  transition:0.3s;
}
.btn-color:hover
{
  color: #ffff;
  background-color: #0277bd;
  border-color: #0277bd;
}
.btn-color-active
{
  color: #ffff;
  background-color: #0288d1;
  border-color: #0288d1;
  box-shadow: none;
}

.side-n{
  box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
  width:100%;
}
.container, .col
{
  padding-left:0;
  padding-right: 0;
}
</style>